import { useEffect } from 'react'
import { Space, Button, message } from 'antd';
import { PlusCircleTwoTone, RightOutlined } from '@ant-design/icons';
import { YhBox } from "@/components/YhBox";
import { AddApplyDrawer } from './AddApplyDrawer';
import { AddNodeDrawer } from './AddNodeDrawer';
import { globalPrompt } from "@/components/YhMessage";
import { approvalService } from '../ApprovalService';
import { useApprovalModel } from "../approvalModel";
import { ApprovalFlowNodeFields, ApprovalFlowFields, UserFields, UserJobFields } from '../ApprovalTypes';
import '../approval.less'

export const RightEdit = () => {

  const {
    guid, clone, selectedShop,
    setAddNodeDrawer, setAddApplyDrawer,
    selectFlow, setSelectFlow,
    approvalFlows, setApprovalFlows, getShopFlow,
    setApplyUsers,
  } = useApprovalModel()

  useEffect(() => {
    if (selectedShop && selectedShop.level == 2) {
      getShopFlow(selectedShop.shopCode);
    }
  }, [selectedShop])

  const addApply = (id: string) => {
    let idx = findIndex(approvalFlows, id);
    let flow = approvalFlows[idx];
    setApplyUsers(flow.applys?.map(item => ({
      "name": item.applyUserName,
      "code": item.applyUserCode,
      "job": item.applyUserDuty,
    })));
    setSelectFlow({ "flowId": id });
    setAddApplyDrawer(true);
  }

  const addNode = (id: string, index: number) => {
    let idx = findIndex(approvalFlows, id);
    let flowNodes = approvalFlows[idx].nodes;
    flowNodes?.splice(index, 0, { "id": guid().replaceAll("-", "") });

    setApprovalFlows(clone(approvalFlows));
  }

  const deleteNode = (id: string, index: number) => {
    let idx = findIndex(approvalFlows, id);
    let flowNodes = approvalFlows[idx].nodes;
    flowNodes?.splice(index, 1);

    setApprovalFlows(clone(approvalFlows));
  }

  //根据ID查询在数组中的位置
  const findIndex = (arr: any[], id?: string) => {
    return arr.findIndex(function (obj) {
      return obj.id === id;
    });
  }

  const addNodeDetail = (id: string, index: number, item?: ApprovalFlowNodeFields) => {
    setSelectFlow({ flowId: id, nodeIndex: index });
    setAddNodeDrawer({ visible: true, node: item });
  }

  const handleSubmitNode = (data: ApprovalFlowNodeFields) => {
    let idx = findIndex(approvalFlows, selectFlow?.flowId);
    let flowNodes = approvalFlows[idx].nodes;
    flowNodes?.splice((selectFlow?.nodeIndex ?? 0), 1, data);

    setApprovalFlows(clone(approvalFlows));
  }

  const handleSelectApply = (applys: UserFields[]) => {
    let idx = findIndex(approvalFlows, selectFlow?.flowId);
    approvalFlows[idx].applys = applys?.map(item => ({
      "applyUserCode": item.code,
      "applyUserName": item.name,
      "applyUserDuty": item.job,
    }))
  }

  const onSubmit = (flow: ApprovalFlowFields) => {
    let flag = true;
    if (flow.applys == null || flow.applys.length == 0) {
      message.error("请选择申请人");
      flag = false;
    }

    flow.nodes?.map(item => {
      if (item.nodeTitle == null) {
        message.error("请完善审核节点");
        flag = false;
      }
    });

    if (flag) {
      let param = {
        id: flow.id,
        shopCode: flow.shopCode,
        applys: flow.applys?.map((item, index) => ({
          ...item,
          "sort": index
        })),
        nodes: flow.nodes,
      }

      approvalService.update(param).then(res => {
        if (res && res.retData == true) {
          message.success('保存成功');
          getShopFlow(flow.shopCode ?? "");
          //清除数据
          setSelectFlow(undefined);
          setApplyUsers([]);
          setApprovalFlows([]);
        }
      }).catch(err => {
        message.error("保存失败" + err);
      })
    }
  }

  const onDelete = (flow: ApprovalFlowFields) => {
    globalPrompt("modal", {
      title: "警告", type: "warning", text: "是否确认删除", onOk: async () => {
        approvalService.delete(flow.id ?? "").then(res => {
          if (res && res.retData == true) {
            message.success('删除成功');
            getShopFlow(flow.shopCode ?? "");
            //清除数据
            setSelectFlow(undefined);
            setApplyUsers([]);
            setApprovalFlows([]);
          }
        }).catch(err => {
          message.error("删除失败" + err);
        })
      },
      cancelShow: true,
    })

  }

  return (
    <div style={{ overflow: 'hidden', overflowX: 'scroll', display: 'inline-flex' }}>
      {approvalFlows.map((flow, index) =>
        <YhBox key={flow.id ?? "" + index} title="流程配置" style={{ width: 360, marginLeft: 10, flex: '0 0 auto', overflow: 'auto' }} >
          <div className="right-head">
            <div className="right-head-button">
              <Button
                type="link"
                shape="round"
                onClick={() => onSubmit(flow)}
              >
                保存
              </Button>
              <Button
                type="link"
                shape="round"
                onClick={() => onDelete(flow)}
              >
                删除
              </Button>
            </div>
          </div>
          <div className='node-list' >
            <div className='node' style={{ marginBottom: 30 }}>
              <div className='node-title'>申请人</div>
              <div className='node-add' onClick={() => { addApply(flow.id ?? "") }}>
                <div className='node-add-user'>
                  {flow.applys?.map((item) =>
                    <div className='node-add-user-child'>
                      <span className='node-add-user-name'>{item.applyUserName}</span>
                    </div>
                  )}
                </div>
                <span className='node-add-icon'><RightOutlined /></span>
              </div>
            </div>
            <div className='node'>
              <div className='node-title'>开始</div>
              <div className='node-subtitle'>审批流程开始</div>
            </div>
            <div className='line'>
              <div className='line-button' onClick={() => addNode(flow.id ?? "", 0)}>
                <Space><PlusCircleTwoTone twoToneColor="blue" /></Space>
              </div>
            </div>
            {flow.nodes?.map((item, index) =>
              <div key={item.id}>
                <div className='node' >
                  <div className='node-title'>
                    <div style={{ flex: 8 }}>
                      {item && item.nodeTitle ? item.nodeTitle : '审批节点'}
                      <span style={{ color: "#7D00FD", marginLeft: 5, fontSize: 14 }}>{item.nodeType == 0 ? '审核' : item.nodeType == 1 ? '抄送' : ''}</span>
                    </div>
                    <span style={{ flex: 1, color: "#3333FF", fontSize: 14 }} onClick={() => deleteNode(flow.id ?? "", index)}>删除</span>
                  </div>
                  <div className='node-add' onClick={() => addNodeDetail(flow.id ?? "", index, item)}>
                    <div className='node-add-user'>
                      <div className='node-add-user-child'>
                        <span className='node-add-user-name'>{item?.approvalUserName ? item.approvalUserName : '添加'}</span>
                        <span className='node-add-user-duty'>{item?.approvalUserDuty}</span>
                      </div>
                    </div>
                    <span className='node-add-icon'><RightOutlined /></span>
                  </div>
                </div>
                <div className='line'>
                  <div className='line-button' onClick={() => addNode(flow.id ?? "", index + 1)}>
                    <Space><PlusCircleTwoTone twoToneColor="blue" /></Space>
                  </div>
                </div>
              </div>
            )}
            <div className='node'>
              <div className='node-title'>结束</div>
              <div className='node-subtitle'>审批流程结束</div>
            </div>
          </div>
        </YhBox>
      )}
      <AddApplyDrawer onSelectOk={handleSelectApply} />
      <AddNodeDrawer onSubmitOk={handleSubmitNode} />
    </div>
  )
}